import React, { useState, useEffect, useContext } from 'react';
import SearchForm from './SearchForm';
import Cart from '../Cart';
import CartTester from '../CartTester';
import { BaseDataContext } from '../../Context/BaseDataContext';

function Home(props) {
  const imageStyle = {
    backgroundImage: 'linear-gradient(to top, rgba(159,211,223, 1), rgba(159,211,223, 0) 80%), url(img/Splash.jpg)',
    backgroundPosition: 'center',
    height: 'calc(100vh - 48px)',
    backgroundSize: 'cover'
  };

  const [baseData, setBaseData] = useContext(BaseDataContext);

  const [searchForm, setSearchForm] = useState({
    priorityProperty: "",
    cabins: [{
      id: 1,
      cabintypeIds: [],
      persons: {
        adults: 2,
        seniors: 0,
        children: 0,
        juniorChildren: 0,
        infants: 0,
      }
    }],
    cruiselineIds: [],
    shipIds: [],
    regionIds: [],
    departureStoppointIds: [],
    onRouteStoppointIds: [],
    arrivalStoppointIds: [],
    roundtrip: false,
    durationMin: 0,
    durationMax: 0,
    departureMin: new Date(), // <- !! 
    departureMax: new Date(new Date().getFullYear(), new Date().getMonth() + 2, 0),
    priceMax: 0,
    pagenumber: 1,
    pagesize: 10,
    sortby: null,
    sortdescending: false
  });
  // used for the api-response.
  const [pagination, setPagination] = useState({
    pagenumber: 1,
    pagesize: 10,
    totalPages: 1,
    totalCount: 0,
  })
  // Prevent from loading default search if token is supplied.
  // So it can get the searchtoken values first.
  const [loadingToken, setLoadingToken] = useState(true);
  const [searchResults, setSearchResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchError, setSearchError] = useState({ hasError: false, message: "" });
  const [formError, setFormError] = useState({ hasError: false, message: "" });
  const [debug, setDebug] = useState("");

  const replacer = function (key, value) {
    
    return value;
  }
  function stringifySearchForm() {
    
    const result = JSON.stringify(searchForm, replacer);

    return result;
  }

  function handleChange(field, value) {
    const updatedSearchForm = { ...searchForm, [field]: value };
    switch (field) {
      case "durationMinMax":
        switch (value) {
          case "0": //  1-2
            updatedSearchForm.durationMin = null;
            updatedSearchForm.durationMax = 2;
            break;
          case "1": //  3-5
            updatedSearchForm.durationMin = 3;
            updatedSearchForm.durationMax = 5;
            break;
          case "2": //  6-9
            updatedSearchForm.durationMin = 6;
            updatedSearchForm.durationMax = 9;
            break;
          case "3": //  10-14
            updatedSearchForm.durationMin = 10;
            updatedSearchForm.durationMax = 14;
            break;
          case "4": //  15+
            updatedSearchForm.durationMin = 15;
            updatedSearchForm.durationMax = null;
            break;
        }
        break;
      case "regionId":
        if (!updatedSearchForm.regionIds.includes(value)) {
          updatedSearchForm.regionIds.push(value);
        }
        else {
          // regionId already exists => remove it from list...
          const i = updatedSearchForm.regionIds.indexOf(value);
          if (i > -1) {
            updatedSearchForm.regionIds.splice(i, 1);
          }
        }
        break;
      case "cruiselineId":
        if (!updatedSearchForm.cruiselineIds.includes(value)) {
          updatedSearchForm.cruiselineIds.push(value);
        }
        break;
    }
    setSearchForm(updatedSearchForm);
  }
  function handleSubmit() {

    var searchurl = '/api/proxy/search/';

    fetch(searchurl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: stringifySearchForm()
    })
      .then(response => {
        if (!response.ok) {
          throw Error("**** Error status " + response.status + " " + response.statusText + " ****");
        }
        return response.json();
      })
      .then((result) => {
        //setSearchResults(result.result.list)
        //setPagination(result.result.pagination)
        //setDebug(JSON.stringify(result.result.list))
        props.history.push("/search/" + result.token)
      })
      .catch(err => {
        setSearchError({ hasError: true, message: err.message });
      })
  }

  useEffect(() => {
    setLoading(true);

    // No token, so load default search.
    setLoadingToken(false);

    fetch("/api/proxy/basedata")
      .then(response => {
        if (!response.ok) {
          debugger;
          throw Error(response.statusText);
        }
        return response.json();
      })
      .then((result) => {
        const updatedSetSearchFormArrays = { ...baseData };
        updatedSetSearchFormArrays.cruiselines = result.result.cruiselines;
        updatedSetSearchFormArrays.ships = result.result.ships;
        updatedSetSearchFormArrays.cabinprimarytype = result.result.cabinprimarytype;
        updatedSetSearchFormArrays.regions = result.result.regions;
        updatedSetSearchFormArrays.stoppoints = result.result.stoppoints;
        updatedSetSearchFormArrays.sortbyList = result.result.sortbyList;
        setBaseData(updatedSetSearchFormArrays);
        setLoading(false);
      })
      .catch(err => {
        debugger;
        setFormError({ hasError: true, message: err.message });
        setLoading(false);
      })
  }, []);

  if (loading) {
    return (
      <React.Fragment>
        Loading...
      </React.Fragment >
    );
  }
  else {
    return (
      <React.Fragment>
        {searchError.hasError && <div className="py-3 text-center bg-red-200 text-red-700 text-base">{searchError.message}</div>}
        <div className="flex flex-col  ">
          <div className=""
            style={imageStyle}>
            <div className="p-8 text-lg text-white hidden">
              <Cart ></Cart>
              <CartTester></CartTester>
            </div>
            <div className="bg-cruise_darkblue absolute bottom-0 left-0 right-0">
              <div className="">
                <SearchForm
                  wrapperClass="flex flex-col sm:flex-row py-2 px-4 searchform"
                  searchForm={searchForm}
                  handleChange={handleChange}
                  handleSubmit={handleSubmit}
                  buttonText="Search"
                  directionUp
                />
              </div>
            </div>
          </div>
        </div>
        <div id="debug">{debug}</div>
      </React.Fragment>
    );
  }
}

export default Home;
